import { render } from "./CategoryUpdate.vue?vue&type=template&id=b11687ca"
import script from "./CategoryUpdate.vue?vue&type=script&lang=js"
export * from "./CategoryUpdate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__